import { actionTypes } from '../actioncreators/actioncreators'

let initialState = {
  allowAutofocus: false
}

export const ExampleMapReducer = (currentState = initialState, action) => {
  switch (action.type) {
    case actionTypes.LOAD_EXAMPLE_MAP:
      return Object.assign({}, currentState, { allowAutofocus: false })
    case actionTypes.ALLOW_AUTOFOCUS:
      return Object.assign({}, currentState, { allowAutofocus: true })
    default:
      return currentState
  }
}

export default ExampleMapReducer
